import type { ViewSwitcher as DxViewSwitcher } from '@devexpress/dx-react-scheduler-material-ui';
import { useTheme } from '@mui/material/styles';
import _ from 'lodash';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Dropdown from '@components/Dropdown/Dropdown';

import { useIsMobile } from '@hooks/useIsMobile';

const messages = defineMessages({
  viewBy: {
    id: 'viewSwitcher.viewBy',
    defaultMessage: 'View by',
  },
});

/**
 * VITALL-styled select component for switching the view on the routine form
 */
const ViewSwitcher = ({ ...props }: DxViewSwitcher.SwitcherProps) => {
  const { formatMessage } = useIntl();
  const mobile = useIsMobile();
  const { palette } = useTheme();
  const { onChange, availableViews, currentView } = props;
  const order = ['Day', 'Week', 'Month'];
  return (
    <div style={{ display: 'contents' }}>
      {!mobile && (
        <div
          style={{
            display: 'inline-block',
            marginRight: '10px',
            color: palette.primary.main,
          }}
        >
          {formatMessage(messages.viewBy)}
        </div>
      )}
      <Dropdown
        onChange={onChange}
        value={currentView.displayName}
        width="auto"
      >
        {_.sortBy(availableViews, (obj) => _.indexOf(order, obj.name)).map(
          (availableView) => (
            <option key={availableView.name} value={availableView.name}>
              {availableView.displayName}
            </option>
          )
        )}
      </Dropdown>
    </div>
  );
};

export default ViewSwitcher;
